document.addEventListener('turbolinks:load', function () {
    initPopovers();
});

function initPopovers() {
    var popoverTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="popover"]'));
    popoverTriggerList.map(function (popoverTriggerEl) {
        // Skip if already initialized
        if (bootstrap.Popover.getInstance(popoverTriggerEl)) return;

        var triggerStyle = popoverTriggerEl.getAttribute('data-trigger-style')
        var modal = popoverTriggerEl.closest('.modal')
        var popoverStyle = { container: modal || 'body' }
        if(triggerStyle !== 'click') {
            popoverStyle['trigger'] = 'hover'
        }
        return new bootstrap.Popover(popoverTriggerEl, popoverStyle);
    });
}

// Re-initialize popovers when any modal is shown (for dynamically rendered content)
document.addEventListener('shown.bs.modal', function () {
    initPopovers();
});

// Click-triggered popovers stay open until their icon is clicked again; close them
// when the user clicks anywhere else (outside both the icon and the popover itself).
document.addEventListener('click', function (event) {
    document.querySelectorAll('[data-bs-toggle="popover"][data-trigger-style="click"]').forEach(function (trigger) {
        var popover = bootstrap.Popover.getInstance(trigger);
        if (!popover || !popover.tip || !document.body.contains(popover.tip)) return;
        if (trigger.contains(event.target) || popover.tip.contains(event.target)) return;

        popover.hide();
    });
});
